import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Compra } from "@/shared/types/compra";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteCompra(id: string): Promise<Compra> {
    await sleep(1000);
    const response = await api.delete("compras/" + id);
    return response.data;
}

export function useDeleteCompraMutation(id: string, mutationConfig: MutationConfig<Compra> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteCompra(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["compras"] });
        },
    })
}

export interface DeleteCompraMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Compra>,
    children?:(mutationResult:MutationResult<Compra>)=>ReactNode
}

export function DeleteCompraMutation({
    id,
    children,
    mutationConfig
}:DeleteCompraMutationProps){
    const mutationResult = useDeleteCompraMutation(id, mutationConfig);
    return children&&children(mutationResult)
}